import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.node,
};

const CheckoutLayoutContainer = ({ children }) => {
  return (
    <div className="min-h-100vh d-flex flex-column bg-gray-light">
      {children}
    </div>
  );
};

CheckoutLayoutContainer.propTypes = propTypes;

export default CheckoutLayoutContainer;
